import type { Maybe } from 'graphql/jsutils/Maybe';

import type { CatalogueProductFeature } from 'src/graphql/generated';

export const adProductFeatureStrategy = (
  featureType: string,
  features?: Array<Maybe<CatalogueProductFeature>>,
) => Boolean(features?.find((feature) => feature?.type === featureType));
